<template>
	<div>
		<form>
			<label>LAN 28</label>
			<input id="lan28-input" type="text" required v-model="lan28">
			<label>MAP BULK</label>
			<input id="mapbulk-input" type="text" required v-model="mapbulk">
			<label>QDROP KS</label>
			<input id="qdrop" type="text" required v-model="qdrop">
			<label>MGSO4</label>
			<input type="text" required v-model="mgs04">
			<div class="submit">
				<button>Calculate</button>
			<p></p>
				<p align="center"><strong> SUM OF BLEND: {{ sumofblend }}</strong></p>
				<p align="center"><strong>ATE MIX: {{ atemix }}</strong></p>
				<p align="center"><strong>ATE TOTAL: {{ atetotal }}</strong></p>
			</div>
			<div align="center">
				<button @click="exportHTML">Export as Word</button>
			  </div>
		</form>
		<div>
			
		</div>
	</div>
</template>

<script>
import { WidthType, BorderStyle, Document, Paragraph, Packer, TextRun } from "docx";
import { saveAs } from 'file-saver';
export default {
	components: {
		Document, Paragraph, Packer, TextRun, saveAs, BorderStyle, WidthType
	},
	data: () => {
		return {
			lan28: '',
			mapbulk: '',
			qdrop: '',
			mgs04: '',
			sum: '',
			atemixtotal: '',
			atetotaldiv: '',
			word: ''	
		}
	},
	computed: {
				sumofblend:function () {
					this.sum = parseInt(this.lan28) + parseInt(this.mapbulk) + parseInt(this.qdrop) + parseInt(this.mgs04)
					return this.sum
					},
				atemix:function () {
					this.atemixtotal = parseFloat(this.lan28 / 2500) + parseFloat(this.mapbulk / 2500) + parseFloat(this.qdrop / 2500) + parseFloat(this.mgs04 / 2500)
					return this.atemixtotal.toFixed(6) 
					},
				atetotal:function () {
					this.atetotaldiv = parseFloat(100 /this.atemixtotal)
					return this.atetotaldiv.toFixed(2)
					},
				runfunctions: function () {
						
				},
	
			},
	methods: {
		exportHTML(){
      		var vm = this, word = `<html xmlns:o='urn:schemas-microsoft-com:office:office xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>${vm.word}</body></html>`;

			var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(word);
			var fileDownload = document.createElement("a");
			document.body.appendChild(fileDownload);
			fileDownload.href = source;
			fileDownload.download = 'document.doc';
			fileDownload.click();
			document.body.removeChild(fileDownload);
			}
	}
	}	

</script>

<style>
form {
	max-width: 430px;
	margin: 30px auto;
	background: white;
	text-align: left;
	padding: 40px;
	border-radius: 10px;
}
label {
	color: #aaa;
	display: inline-block;
	margin: 25px 0 15px;
	font-size: 1em;
	text-transform: uppercase;
	letter-spacing: 1px;
	font-weight: bold;
}
input {
	display: block;
	padding: 10px;
	width: 100%;
	box-sizing: border-box;
	border: none;
	border-bottom: 1px solid #ddd;
	color: #555;
}
button {
	background: #0b6dff;
	border: 0;
	padding: 10px 20px;
	margin-top: 20px;
	color: white;
	border-radius: 20px;
}
.submit {
	text-align: center;
}
</style>

